export enum ModuleIFMStatus {
  success = 'success',
  neutral = 'neutral',
}

export enum ModuleIFMLayout {
  column = 'column',
  row = 'row',
}

export interface ModuleIFMItem {
  id: string;
  text: string;
  status: ModuleIFMStatus;
  value?: string;
}

export interface ModuleIFMProps {
  centralValue: string;
  className?: string;
  items: ModuleIFMItem[];
  layout?: ModuleIFMLayout;
  status?: ModuleIFMStatus;
  testId?: string;
}
